import http from 'Services/HttpService';

import { baseUrl } from 'Utils/envLoader';

const FonctionService = {
    getFonctionById: (id) => {
        return http.get(`${baseUrl}/cliami/fonctions/${id}`);
    },

    getFonctions: () => {
        return http.get(`${baseUrl}/cliami/fonctions`);
    },

    saveFonction: (fonction) => {
        if (!fonction.fonctionId) {
            return http.post(`${baseUrl}/cliami/fonctions/create`, fonction);
        } else {
            return http.put(`${baseUrl}/cliami/fonctions/update/${fonction.fonctionId}`, fonction);
        }
    },

    deleteFonction: (fonction) => {
        return http.delete(`${baseUrl}/cliami/fonctions/delete/${fonction.fonctionId}`);
    },
};

export default FonctionService;
